<template>
  <div>
    <div class="form-list">
      <div class="form-header">선</div>
      <el-form :model="formModel" label-width="120px" label-position="left">
        <el-form-item label="대시">
          <el-checkbox v-model="formModel.lineOptions.dashType" :true-label="'dash1'" :false-label="'default'"></el-checkbox>
        </el-form-item>
        <el-form-item label="두께">
          <el-input-number v-model="formModel.strokeOptions.weight" controls-position="right" :style="fullField" :min="1" :max="5"></el-input-number>
        </el-form-item>
        <el-form-item label="색상">
          <w-color-field v-model="formModel.strokeOptions.color" :style="fullField"></w-color-field>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import WColorField from '@/components/form/ColorField';

import ObjectProperty from '@/mixins/topologymap/object-property';

export default {
  name: 'WVirtualLanProperty',
  components: {
    WColorField,
  },
  mixins: [ObjectProperty],
  data() {
    return {};
  },
};
</script>
<style module>
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/property/VirtualLanProperty.vue